export enum OrdersIntentionsApprovalType {
  ANALITICO,
  SINTETICO,
  CAMPANHA,
}
